import { render, staticRenderFns } from "./tracking_order.vue?vue&type=template&id=19b996b8&"
import script from "./tracking_order.vue?vue&type=script&lang=js&"
export * from "./tracking_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports